import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import "../css/delivery.scss";

function Delivery() {
  return (
    <body className=" color-scheme color-scheme--scheme-1">
      <Header />
      <div className="container-pages page-width--narrow section-template--18612137558167__main-padding">
        <div className="page-rte rte scroll-trigger animate--slide-in">
          <h1>Shipping Information</h1>
          <p>
            We're working hard to get your order prepared and shipped as quickly
            as possible.
          </p>
          <p>
            We ask that you allow our team two to three business days to pack up
            and ship out your order, though it may often be quicker. Our
            shipping department is closed on Saturdays, Sundays, and holidays.
            <br />
            <br />
            If your order is urgent or if you need to confirm the date an item
            will be shipped, please give us a call at our toll-free number:
            773-989-0900. We will do our best to help.
          </p>
          <p>
            <strong>
              As you’re deciding between shipping methods, here is some helpful
              information:
            </strong>
          </p>
          <p>
            Economy Shipping and Free Economy Shipping are provided by DHL. If
            you need your package urgently, we recommend you forego these
            options and select an expedited shipping method (UPS Next Day Air,
            UPS 2nd Day Air, etc.).
          </p>
          <p>
            UPS Next Day Air is the only shipping method providing guaranteed
            shipping (your package will be delivered the next business day or
            else the cost of shipping is refundable). Orders must be placed
            before 12pm (CST) Monday - Friday to qualify. Our carriers do not
            deliver on Saturdays, Sundays, or holidays. For example, a UPS Next
            Day Air order placed on Friday will arrive the next business day
            which is usually a Monday (excluding holidays).
            <br />
            <br />
            UPS 2nd Day Air and UPS Ground are currently experiencing relatively
            consistent shipping times but are not refundable if they do not
            arrive as scheduled.
          </p>
          <h4>
            <strong />
            <br />
          </h4>
          <h4>
            <b>Shipping Package Protection</b>
          </h4>
          <p>
            Our new package protection program allows us to take care of
            shipping issues for you quickly and with less stress. Get peace of
            mind with a “Delivery Guarantee” in the event your delivery is lost,
            stolen, or damaged during transit. We handle the claims while you
            enjoy your purchases.
          </p>
          <p>
            <br />
            Leave the shipping protection selected and we will reship or refund
            your order if the package is lost, stolen, or damaged. You do not
            have to file a claim, we will take care of this for you. <br />
            <br />
            Deselect the shipping protection if you prefer to file a package
            claim yourself in the event your package incurs a problem. Please
            note: by deselecting shipping protection, we will not be liable for
            any lost, stolen, or damaged packages.
          </p>
          <p>&nbsp;</p>
          <h4>
            <strong />
            <br />
          </h4>
          <h4>
            <strong />
            <br />
          </h4>
          <h4>
            <strong>Shipping Methods</strong>
          </h4>
          <p>
            <strong />
            <strong>Free Economy Shipping</strong>
          </p>
          <p>
            <span style={{ fontWeight: 400 }}>
              Sadiemall offers free economy shipping for orders with a subtotal
              of $95, before taxes, and after discounts, that are being shipped
              to any of the lower 48 states and does not include Alaska or
              Hawaii. Free economy shipping usually arrives in five to ten
              business days.
            </span>
          </p>
          <p>
            <strong>Economy Shipping</strong>
          </p>
          <p>
            Economy shipping and Free Economy Shipping is provided by DHL who
            brings the package to the Post Office for the final delivery. We do
            not recommend this shipping method if your package is needed
            urgently. Economy shipping usually arrives in five to ten business
            days.
          </p>
          <p>
            <strong>UPS Ground</strong>
          </p>
          <p>
            <span style={{ fontWeight: 400 }}>
              Shipping rates vary based on weight and destination. Our carrier
              does not pick up or deliver orders on Saturdays, Sundays, or
              holidays. UPS Ground is scheduled to arrive anywhere from two
              to&nbsp;seven business days based on your destination.
            </span>
            <br />
            <strong />
          </p>
          <p>
            <strong>UPS 2nd Day Air</strong>
          </p>
          <p>
            <strong>
              <span style={{ fontWeight: 400 }}>
                The cut off for shipping out 2nd Day Air orders is 12pm CST,
                Monday-Friday. UPS 2nd Day Air orders are experiencing
                relatively consistent shipping times but are not refundable if
                they do not arrive as scheduled. Orders placed after 12pm will
                ship the next business day. Our carrier does not pick up or
                deliver orders on Saturdays, Sundays, or holidays.&nbsp;
              </span>
            </strong>
          </p>
          <p>
            <strong>Next Day Air</strong>
          </p>
          <p>
            <span style={{ fontWeight: 400 }}>
              UPS Next Day Air is the only shipping method providing guaranteed
              shipping (your package will be delivered the next business day, or
              else the cost of shipping is refundable). The cut off for shipping
              out expedited orders is 12pm CST, Monday-Friday. Our carrier does
              not pick up or deliver orders on Saturdays, Sundays, or holidays.
              Next Day Air orders placed on a Friday will not arrive until
              Monday (excluding holidays).
            </span>
          </p>
          <p>
            <strong>International Shipping</strong>
          </p>
          <p>
            <span style={{ fontWeight: 400 }}>
              We currently ship to Canada, Australia and New Zealand, and will
              be expanding to other international countries soon.
            </span>
          </p>
          <p>
            <span style={{ fontWeight: 400 }}>
              All international orders are classified as DDP, or Delivered Duty
              Paid. This means we collect applicable duties and taxes upfront in
              order to streamline the shipping process for you. This method
              expedites transit through customs and eliminates any unexpected
              charges upon delivery. <br />
            </span>
            <span style={{ fontWeight: 400 }}>
              <br />
            </span>
            <span style={{ fontWeight: 400 }}>
              International orders do not have a guaranteed delivery time and
              are currently experiencing delays. Thank you in advance for your
              patience.
            </span>
          </p>
          <section>
            <section>
              <section />
            </section>
          </section>
        </div>
      </div>

      <Footer />
    </body>
  );
}

export default Delivery;
